import { render } from "./JobCategory.vue?vue&type=template&id=7ffbd3fd"
import script from "./JobCategory.vue?vue&type=script&lang=js"
export * from "./JobCategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__